export enum FeatureFlags {
  MAINTENANCE_MODE = 'display_maintenance_page',
}
